import { Breakpoint, useMediaQuery, useTheme } from '@mui/material';

/**
 * Query media check for max-width
 * @param breakPoint
 */
export const useIsScreenSizeMax = (breakPoint: Breakpoint) => {
  const theme = useTheme();

  return useMediaQuery(theme.breakpoints.down(breakPoint));
};

/**
 * Query media check for min-width
 * @param breakPoint
 */

export const useIsScreenSizeMin = (breakPoint: Breakpoint) => {
  const theme = useTheme();

  return useMediaQuery(theme.breakpoints.up(breakPoint));
};
